import React, { useContext } from "react";
import { Col, Button } from "react-bootstrap";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { DesignContext } from "contexts/DesignContext";
import { themeDefault } from "../../themes/containerTheme";
import useAuth from "hooks/useAuth";
import { getShowUiConfig } from "designer/component/action/Config";
import {
  checkHasShow,
  checkIsShow,
} from "designer/component/action/condition/Action";
import {
  getDesignerDropProps,
  getDesignerFocusItemProps,
} from "./customDragDrop";

const DropWrapper = (props) => {
  let { uischema, path, children } = props;

  const designContext = useContext(DesignContext);
  const { current, deleteUi, closeUi, jsonForm } = designContext;

  const { config } = useAuth();
  const isShowUiConfig = getShowUiConfig({ uischema, config, jsonForm });
  let hasShow = checkHasShow({ designContext, uischema, config: props.config });
  let isShow = checkIsShow({ designContext, uischema, config: props.config });
  const dropProps = getDesignerDropProps(uischema.key);
  const focusItemProps = getDesignerFocusItemProps({
    designContext,
    uischema,
    config: props.config,
  });
  const isCurrent = current.ui.key === uischema.key;
  const designerName = uischema.name;
  const designerFrameStyle = {
    border: `1px ${isCurrent ? "solid" : "dashed"} ${
      isCurrent ? "#FFB64D" : "#d5dce6"
    }`,
    backgroundColor: isCurrent ? "#fffdf7" : "#fff",
    boxShadow: isCurrent
      ? "0 0 0 2px rgba(255, 182, 77, .16)"
      : "0 1px 2px rgba(15, 23, 42, .04)",
  };
  const designerToolbarStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "4px",
    minHeight: "28px",
    padding: "3px 5px",
    borderBottom: "1px solid #eef2f7",
    backgroundColor: isCurrent ? "#fff8ec" : "#f8fafc",
  };
  const designerNameStyle = {
    maxWidth: "60%",
    padding: "2px 8px",
    borderRadius: "4px",
    backgroundColor: "#e9ecef",
    color: "#495057",
    fontSize: "12px",
    lineHeight: "18px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };
  const designerActionStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "4px",
    marginLeft: "auto",
  };

  return (
    <Col sm={uischema.layoutWidth} hidden={hasShow ? !isShow : !isShowUiConfig}>
      <div
        style={designerFrameStyle}
        className="position-relative m-1 rounded"
        {...focusItemProps}
      >
        <div style={designerToolbarStyle}>
          {designerName && (
            <span style={designerNameStyle} title={designerName}>
              {designerName}
            </span>
          )}
          <div style={designerActionStyle}>
            <Button
              variant={"secondary"}
              className="btn-icon py-0 px-1 ml-1 mr-0"
              title="Hide"
              onClick={() => closeUi(uischema.key)}
            >
              <i className="feather icon-minus"></i>
            </Button>
            <Button
              variant={"danger"}
              className="btn-icon py-0 px-1 ml-1 mr-0"
              title="Delete"
              onClick={() => deleteUi(uischema, path, uischema.key)}
              hidden={!uischema.isCanDelete}
            >
              <i className="feather icon-trash"></i>
            </Button>
          </div>
        </div>
        <div className="w-100" {...dropProps}>
          <MuiThemeProvider theme={themeDefault}>
            <div
              style={{
                padding: uischema.layoutPadding ?? "",
                margin: uischema.layoutMargin ?? "",
              }}
            >
              {children}
            </div>
          </MuiThemeProvider>
        </div>
      </div>
    </Col>
  );
};

export default DropWrapper;
